import React from "react";
import styled from "styled-components";
import { Footer, footerOptions, optionsFor } from "@pga/pga-component-library";
import { withAuthProvider } from "../../lib/auth";

const FooterContainer = styled.div`
  text-align: left;
`;

const sanitizeFooterSections = (sections) => {
  if (!Array.isArray(sections)) {
    return sections;
  }

  return sections.map((section) => {
    if (!Array.isArray(section.options)) {
      return section;
    }

    return {
      ...section,
      options: section.options.map((option) =>
        option?.link === "javascript:void(0)"
          ? { ...option, link: "#" }
          : option
      ),
    };
  });
};

const DirectoryFooter = ({ me }) => (
  <FooterContainer>
    <Footer
      sections={sanitizeFooterSections(optionsFor(me))}
      copyright={footerOptions.copyrightMessage}
    />
  </FooterContainer>
);

export default withAuthProvider(DirectoryFooter);
